import { render, staticRenderFns } from "./TimetableEditor.vue?vue&type=template&id=4333fab4&scoped=true"
import script from "./TimetableEditor.vue?vue&type=script&lang=ts"
export * from "./TimetableEditor.vue?vue&type=script&lang=ts"
import style0 from "./TimetableEditor.vue?vue&type=style&index=0&id=4333fab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4333fab4",
  null
  
)

export default component.exports